import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "../../store";
import axios from "axios";
import { required, maxLength, minValue, maxValue } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.js";
import { blockSpecialChars } from '@/utils/validators';

export default {
  name: "PaymentAttributeCreate",
  components: { MainLayout, Loading, Select2Multiple },

  data() {
    return {
      isLoading: false,
      attribute_name: "",
      category_id: null,
      type: null,
      order: 1,
      description: "",
      is_active: 1,
      submitted: false,
      disabled: false,
      STATUS: CONFIG.STATUS,
      CATEGORIES: CONFIG.CATEGORIES,
      TYPES: CONFIG.TYPES
    };
  },

  validations: {
    attribute_name: { required, maxLength: maxLength(255) },
    category_id: { required },
    type: { maxLength: maxLength(10) },
    order: { required, minValue: minValue(1) , maxValue: maxValue(1000)},
    description: { maxLength: maxLength(1000) },
    is_active: { required }
  },

  methods: {
    handleKeyDown(event) {
      blockSpecialChars(event);
    },
    confirmRegister() {
      this.submitted = true;
      this.disabled = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }

      this.register();
    },

    register() {
      const request = {
        attribute_name: this.attribute_name,
        category_id: this.category_id,
        type: this.type,
        order: this.order,
        description: this.description,
        is_active: this.is_active,
        created_id: store.state.user.id
      };

      axios.post("/paymentAttribute/create", request)
        .then(() => {
          this.$notification.success("Payment Attribute added successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: "paymentAttributeList" });
        })
        .catch(error => {
          this.disabled = false;
          if (error.response?.status === 422) {
            this.$notification.error(error.response.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          } else if (error.response?.status === 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          } else {
            console.error("Unexpected error:", error);
          }
        });
    },

    showList() {
      this.$router.push({ name: "paymentAttributeList" });
    }
  }
};
